<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800px"
        v-model="dialog"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-list-item v-bind="activatorProps">
                <v-list-item-title>
                    Cambiar estado
                    <v-icon>mdi mdi-arrow-right</v-icon>
                </v-list-item-title>
            </v-list-item>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card>
                <v-toolbar title="Cambiar estado de la solicitud" style="text-align: center;" class="modal-header"></v-toolbar>
                <v-card-text>
                    <p class="my-text-black">Cantidad solicitada este año: {{ this.cantidadSolicitada }}</p>
                    <p class="my-text-black">Cantidad autorizada este año: {{ this.cantidadAutorizada }}</p>
                    <v-divider id="divider"></v-divider>
                    <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
                        <v-select
                            v-model="estado"
                            :items="estados"
                            item-title="nombre"
                            label="Estado"
                            solo
                            dense
                            class="mb-5 mt-5"
                            :rules="obligatorio"
                            @update:model-value="mostrarAviso(estado)"
                        >
                        </v-select>
                        <p class="ml-5" v-if="mostrarTexto" style="color: red;">Una vez enviada la observación no se podrán agregar más hasta que el policonsultorio resuelva la actual.</p>
                        <v-textarea
                            v-if="estado != '' && estado != 'Autorizar' && estado != 'Facturable'"
                            v-model="motivo"
                            :label="this.estado == 'Rechazar' ? 'Motivo de rechazo' : 'Observaciones'"
                            solo
                            dense
                            class="mb-5 mr-5 ml-5"
                            :rules="obligatorio"
                        >
                        </v-textarea>
                        <v-row class="mr-5">
                            <v-col cols="12" md="8"></v-col>
                            <v-col cols="12" md="2">
                                <v-btn
                                    text="Cancelar"
                                    id="boton-verde"
                                    @click="isActive.value = false"
                                    :disabled="cargando == true"
                                    :loading="cargando == true"
                                ></v-btn>
                            </v-col>                            
                            <v-col cols="12" md="2">                                
                                <v-btn
                                    type="submit"
                                    id="boton-verde"
                                    text="Cambiar"
                                    :disabled="!valid || cargando == true"
                                    :loading="cargando == true"
                                ></v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </template>
    </v-dialog>
</template>

<style src="../assets/general.css"></style>
<script>
    import { obligatorio } from '@/_helpers/rules';
    import PacienteService from '@/api/PacienteService';

    const pacienteService = new PacienteService();
    
    export default {
        props: {
            estados: {
                type: Array,
                required: true
            },
            sistema: {
                type: String,
                required: true
            },
            numeroAfiliado: {
                type: String,
                required: true
            },
            obraSocial: {
                type: String,
                required: true
            },
            practicasIds: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                dialog: false,
                estado:'',
                motivo:'',
                valid: false,
                cargando: false,
                obligatorio: obligatorio,
                mostrarTexto: false,
                // Variables para manejar la cantidad de practicas anuales
                cantidadSolicitada: 0,
                cantidadAutorizada: 0,
            }
        },
        async mounted() {
            await this.buscarCantidadesPracticaAnual();
        },
        methods: {
            handleSubmit() {
                let nuevoEstado = {
                    estado: this.estado,
                    motivo: this.motivo
                }
                this.$emit('cambiar-estado', nuevoEstado);
                this.dialog = false;
            },
            mostrarAviso(estado){
                if(estado == 'Observar' && this.sistema == 'Klinicos'){
                    this.mostrarTexto = true;
                }
                else{
                    this.mostrarTexto = false;
                }
            },
            async buscarCantidadesPracticaAnual(){
                //Aca voy al back a buscar cantidad solicitada de esa practica por ese paciente en este año
                // y cantidad autorizada de esa practica por ese paciente en este año
                const responseCantidades = await pacienteService.getCantidadesAnualesPracticaAfiliado(
                    this.practicasIds[0], 
                    this.numeroAfiliado, 
                    this.obraSocial
                );

                if(responseCantidades && responseCantidades.status == 200){
                    this.cantidadSolicitada = responseCantidades.data.cantidadSolicitada;
                    this.cantidadAutorizada = responseCantidades.data.cantidadAutorizada;
                }
                else {
                    //mostrar error
                }
            }
        },
    }
</script>